
import { forkJoin, Subscription, of, filter } from 'rxjs';
import { Component, OnInit, ViewChild, HostListener } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import moment from 'moment-timezone';
import 'moment-timezone';
import { MessageService } from 'primeng/api';

import { ArticleApiService } from '../../api/article/article-api.service';
import { PreferredMethodOfContactApiService } from '../../api/preferred-method-of-contact/preferred-method-of-contact-api.service';
import { IndustryApiService } from '../../api/industry/industry-api.service';
import { NewsroomApiService } from '../../api/newsroom/newsroom-api.service';
import { AgilityApiService } from '../../api/agility/agility-api.service';
import { ArticleViewModel } from '../../models/ArticleViewModel';
import { ArticleContactViewModel } from '../../models/ArticleContactViewModel';
import { ArticleStatusEnum } from '../../enums/ArticleStatus.enum';
import { ArticleSummaryWithCountViewModel } from '../../models/ArticleSummaryWithCountViewModel';
import { ArticleSummaryViewModel } from '../../models/ArticleSummaryViewModel';
import { BodyContentTypesEnum } from '../../enums/BodyContentTypes.enum';

import { ContactsDataSource } from '../article/contacts.datasource';
import { LinksDataSource } from '../article/links.datasource';
import { ArticleComponentViewModel } from '../article/article-component-viewmodel';
import { Utils } from '../../utils/utils';
import { ReleaseCountViewModel } from '../../models/ReleaseCountViewModel';
import { ArticleComponent } from '../article/article.component';
import { AccountApiService } from '../../api/account/account-api.service';
import { BodyContentsModel } from '../../models/BodyContentsModel';
import { PreferencesModel } from '../../../../Core/Users/models/preferences.model';
import { StoryModel } from '../../../../api/amplify/model/amplify-reponse.model';
import { AmplifyTypesEnum } from '../../../../api/amplify/enums/amplify-types.enum';
import { NewsroomSideBarModel } from '../../../Shared/models/newsroom-side-bar.model';
import { NewsroomSideBarItemModel } from '../../../Shared/models/newsroom-side-bar-item.model';
import { TimeModel } from '../../../../Common/Forms/models/time.model';
import { deliverySchedulingTypesEnum } from '../../../../Common/Forms/enums/delivery-scheduling-types.enum';
import { StatusEnum } from '../../../Newsroom/enums/status.enum';
import { ConfigService } from '../../../../Core/Config/services/config.service';
import { TimeHelper } from '../../../../Common/Forms/helpers/time.helper';
import { DateHelper } from '../../../../Common/Forms/helpers/date.helper';
import { EmailDistributionFilterModel, NewsroomFilterModel } from '../../../../api/amplify/model/amplify-request.model';
import { timeFormatsEnum } from '../../../../Core/Users/enums/time-formats.enum';
import { StorySearchParams } from '../../../../api/story/model/story-search-Query-Params.model';
import { AmplifyStoryResultModel } from '../../../../api/amplify/model/amplify-unified.model';
import { UnifiedStoryResponseModel } from '../../../../api/story/model/story-response.model';
import { StoryContact } from '../../../../api/story/model/story-contact.model';
import { tensesEnum } from '../../../../Common/Forms/enums/tenses-enum';
import { Title } from '@angular/platform-browser';
import { CurrentUserStateService } from '../../../../Core/Users/services/current-user-state.service';
import { userPermissionsEnum } from '../../../../Core/Users/enums/user-permissions.enum';
import { DistributionRegionsEnum } from '../../enums/DistributionRegions.enum';
import { DropdownOptionModel } from '../../../../Common/Forms/models/dropdown-option.model';
import { CoreDialogService } from '../../../../Core/Dialogs/services/dialog.service';
import { ConfirmDialogComponent } from '../../../../Common/Dialogs/components/ConfirmDialog/confirm-dialog.component';
import { ConfirmDialogModel } from '../../../../Common/Dialogs/models/confirm-dialog.model';
import { AbstractHypeService } from '../../../../Common/Layout/services/abstract-hype.service';
// eslint-disable-next-line @typescript-eslint/naming-convention
export const NewswireConstants: any = {
    unsavedHeading: 'Unsaved Changes',
    unsavedMessage: 'You have unsaved changes.\nAre you sure you want to continue without saving?\nAll unsaved changes will be lost.',
    unsavedMessageHtml: 'You have unsaved changes.<br/>Are you sure you want to continue without saving?<br/>All unsaved changes will be lost.',
    unsavedContinueLabel: 'Continue',
    unsavedCancelLabel: 'Cancel',
    deleteFailedHeading: 'Invalid Action',
    deleteFailedMessage: 'Only Press Releases in draft status may be deleted.',
    deleteHeading: 'Delete Selected Press Releases?',
    deleteMessage: 'Are you sure you want to delete the following Press Releases?',
    deleteItemsStart: '<br/>',
    deleteItemStart: '<br/>',
    deleteItemEnd: '',
    deleteItemsEnd: '',
    deleteCancelLabel: 'Cancel',
    deleteConfirmLabel: 'Delete',
    retractFailedHeading: 'Cancellation Failed',
    retractFailedMessage: 'The request to retract this Press Release can not be completed.'
        + '<br/>Please contact Accesswire editorial for more information.'
        + '<br/><br/>Phone: 888.952.4446 x1'
        + '<br/>Email: cs@accesswire.com',
    successSeverity: 'success',
    errorSeverity: 'error',
    serverErrorHeading: 'Error',
    serverErrorMessage: 'An error has occurred. Please try again or contact Support for assistance.',
    pressReleaseMessage: 'Press Release ',
    createPressReleaseHeading: 'Press Release Saved',
    createMessage: ' has been successfully saved.',
    updateStoryHeading: 'Press Release Updated',
    updateMessage: ' has been successfully updated.',
    reviewPressReleaseHeading: 'Press Release In Review',
    reviewMessage: ' is now in review.',
    retractPressReleaseHeading: 'Press Release Retracted',
    retractMessage: ' has been successfully retracted.',
    detelePressReleaseHeading: 'Press Release Deteled',
    deteleInfoMessage: ' has been successfully deteled.',
    statusLabels: {
        [ArticleStatusEnum.Draft]: 'DRAFT',
        [ArticleStatusEnum.Scheduled]: 'SCHEDULED',
        [ArticleStatusEnum.Posted]: 'PUBLISHED',
        [ArticleStatusEnum.Retracted]: 'RETRACTED',
        [ArticleStatusEnum.Failed]: 'FAILED',
        [ArticleStatusEnum.InReview]: 'IN REVIEW',
        [ArticleStatusEnum.Rejected]: 'FAILED REVIEW',
    },
    sidebarItemLabel: 'Press Release',
    sidebarNoItemsText: 'No Press Releases',
    sidebarAmplifyLabel: 'NEW PRESS RELEASE',
    sidebarSectionNewsroom: 'Newsroom',
    sidebarSectionNewswire: 'Newswire',
    newsroomMenuValue: userPermissionsEnum.newsroom,
    hypeText1: 'Amplify your press release by distributing to a broad range of outlets with our flat-fee newswire service.',
    hypeText2: 'Let\'s get started.'
};

@Component({
    selector: 'agpr-newswire',
    templateUrl: './newswire.component.html',
    styleUrls: ['./newswire.component.scss'],
    providers: [
        {
            provide: AbstractHypeService,
            useExisting: NewswireComponent
        }
    ],
    standalone: false
})
export class NewswireComponent extends AbstractHypeService implements OnInit {
    @ViewChild(ArticleComponent) articleComponent: ArticleComponent;
    public preferences: PreferencesModel;
    imageStreamBase64: RegExp = /^data:[^;]+;base64,/;
    amplifyMaxRecentResults: number = 5;
    amplifyResultsPageSize: number = 25;
    amplifyTotalRecords: number = 0;
    storyList: StoryModel[] = [];
    storyTypes = [
        { label: AmplifyTypesEnum.Recent, value: AmplifyTypesEnum.Recent },
        { label: AmplifyTypesEnum.Newsroom, value: AmplifyTypesEnum.Newsroom },
        { label: AmplifyTypesEnum.Newswire, value: AmplifyTypesEnum.Newswire  }
    ];
    totalStories: number = 0;
    showStoryPreview: boolean = false;
    sidebarModel: NewsroomSideBarModel = new NewsroomSideBarModel();
    selectedItem: NewsroomSideBarItemModel = new NewsroomSideBarItemModel();
    public displayAmplifyDialog: boolean = false;
    public industryList: DropdownOptionModel[] = [];
    public article: ArticleViewModel = new ArticleViewModel();
    contactsDataSource: ContactsDataSource = new ContactsDataSource();
    linksDataSource: LinksDataSource = new LinksDataSource();
    showPublishLater: boolean = false;
    publishDate: Date = null;
    publishTime: TimeModel = null;
    deliverySchedulingType: deliverySchedulingTypesEnum = deliverySchedulingTypesEnum.future;
    showLoader: boolean = false;
    showAmplifyLoading: boolean = false;
    articleComponentViewModel: ArticleComponentViewModel = new ArticleComponentViewModel();
    selectedAmplifyType: AmplifyTypesEnum = AmplifyTypesEnum.Recent;
    createdBy: string = '';
    preferredMethodList: DropdownOptionModel[] = [];
    minDate: Date = null;
    public remainingUSReleases: number = -1;
    public remainingUKReleases: number = -1;
    public remainingCanadaReleases: number = -1;
    public remainingNorthAmericaReleases: number = -1;
    public inEditMode: boolean = false;
    private accountName: string;
    public editingDelay: number = null;

    public maxImageContents: number = 10;
    public maxTextContents: number = 10;
    public maxVideoContents: number = 10;
    public remainingImageContents: number = 0;
    public remainingTextContents: number = 0;
    public remainingVideoContents: number = 0;
    storyStatusMapping = {
        [StatusEnum.DRAFT]: ArticleStatusEnum.Draft,
        [StatusEnum.SCHEDULED]: ArticleStatusEnum.Scheduled,
        [StatusEnum.PUBLISHED]: ArticleStatusEnum.Posted,
        [StatusEnum.RETRACTED]: ArticleStatusEnum.Retracted,
        [StatusEnum.FAILED]: ArticleStatusEnum.Failed,
        [StatusEnum.INREVIEW]: ArticleStatusEnum.InReview,
        [StatusEnum.FAILED_REVIEW]: ArticleStatusEnum.Rejected
    };
    public sidebarItemLabel: string = NewswireConstants.sidebarItemLabel;
    public sidebarNoItemsText: string = NewswireConstants.sidebarNoItemsText;
    public sidebarAmplifyLabel: string = NewswireConstants.sidebarAmplifyLabel;
    public newswireSidebarSection: DropdownOptionModel = new DropdownOptionModel(
        NewswireConstants.sidebarSectionNewswire,
        '/Newswire'
    );
    public sidebarSections: DropdownOptionModel[] = [
        this.newswireSidebarSection
    ];
    public sidebarSelectedSectionValue: DropdownOptionModel = this.newswireSidebarSection;

    private subscriptions: Subscription[];

    constructor(
        private articleApi: ArticleApiService,
        private router: Router,
        private activatedRoute: ActivatedRoute,
        public configService: ConfigService,
        private agilityApi: AgilityApiService,
        private newsroomApi: NewsroomApiService,
        private industryApi: IndustryApiService,
        private preferredMethodOfContactApi: PreferredMethodOfContactApiService,
        private accountApiService: AccountApiService,
        private currentUserStateService: CurrentUserStateService,
        private timeHelper: TimeHelper,
        private dateHelper: DateHelper,
        private titleService: Title,
        private messageService: MessageService,
        private coreDialogService: CoreDialogService
    ) {
        super();
        this.titleService.setTitle('Newswire - Agility');
        this.createSubscriptions();
        this.setEditingDelay();
        this.setMinSchedulingDate();
        this.refreshArticleSummaries();

        this.hypeConfig = {
            icon: 'fa-kit-duotone fa-agpr-hype-newswire',
            headingText: NewswireConstants.sidebarSectionNewswire,
            line1Text: NewswireConstants.hypeText1,
            line2Text: NewswireConstants.hypeText2,
            linkText: NewswireConstants.sidebarAmplifyLabel
        };
        this.hypeConfigProvider.next(this.hypeConfig);
    }

    @HostListener('window:beforeunload', ['$event'])
    pageUnload($event) {
        if (this.inEditMode) {
            $event.returnValue = NewswireConstants.unsavedMessage;
        }
    }

    private refreshArticleSummaries(): void {
        this.showLoader = true;
        this.articleApi.getArticleSummaries('')
            .subscribe({
                next: (summaries) => this.onGetArticleSummaries(summaries),
                error: (error) => this.onApiError(error)
            });
    }
    public showMessage(headMessage: string, message: string, messageSeverity: string) {
        this.messageService.add({severity: messageSeverity, summary: headMessage, detail: message});
    }

    private onApiError(error): void {
        this.showLoader = false;
        this.showMessage(NewswireConstants.serverErrorHeading, NewswireConstants.serverErrorMessage, NewswireConstants.errorSeverity);
    }
    private onApiErrorRetracting(error): void {
        this.article.articleStatus = ArticleStatusEnum.InReview;
        this.showLoader = false;
        this.showDialog(
            NewswireConstants.retractFailedHeading,
            NewswireConstants.retractFailedMessage
        );
    }

    public onRightSideBarModelChanged(): void {
        this.articleComponent.onModelChanged();
    }

    public sidebarSectionChanged(value): void {
        if (value) {
            this.router.navigate([value]);
        }
    }

    private onGetArticleSummaries(
        summariesWithCount: ArticleSummaryWithCountViewModel
    ): void {
        this.sidebarModel.items = [];
        this.sidebarModel.totalItemCount = 0;
        this.totalStories = 0;
        summariesWithCount.summaries.forEach(summary => {
            const itemModel: NewsroomSideBarItemModel = new NewsroomSideBarItemModel();
            itemModel.id = summary.articleId;
            itemModel.name = summary.articleName;
            itemModel.status = NewswireConstants.statusLabels[summary.articleStatus];
            itemModel.options = [
                {label: 'Lhp.actions.delete', icon: 'fa-regularfa-duotone  fa-trash-can', command: (data) => this.deleteArticle((data as any).item) },
                // TODO newswire is not working fro test environment, should add this line back when newswire is working
                // {label: 'Lhp.actions.copy', icon: 'fa-kit-duotone fa-agpr-copy', command: (data) => this.copyNewswire(data)}
            ];
            this.sidebarModel.items.push(itemModel);
        });
        this.sidebarModel.totalItemCount = summariesWithCount.totalCount;
        this.totalStories = this.sidebarModel.totalItemCount;
        this.showLoader = false;
    }

    // TODO: newswire is not working fro test environment, should add this line back when newswire is working
    // copyNewswire(sideBarItem: NewsroomSideBarItemModel){
    //     const inputConfig: TextInputDialogModel = {
    //         inputs: {
    //             width: 280,
    //             heading: 'Monitoring.copySubscription',
    //             okLabel: 'Core.button.copy',
    //             placeholder: 'Enter name',
    //             formValidator: (name: string) => [],
    //             submit: (name: string) => {
    //                 return of(null);
    //             }
    //         }
    //     };
    //     this.coreDialogService.open(TextInputDialogComponent, inputConfig);
    // }


    public onCreateNewArticle(): void {
        this.articleApi.getReleaseCounts().subscribe({
            next: (data) => {
                const releaseCounts: ReleaseCountViewModel[] = data;
                this.setRemainingReleaseCounts(releaseCounts);
                this.showStoryPreview = true;
                this.displayAmplifyDialog = false;
                this.createdBy = '';
                this.article = new ArticleViewModel();
                this.contactsDataSource.dataSource = [];
                this.linksDataSource.dataSource = [];
                this.articleComponentViewModel = new ArticleComponentViewModel();
                this.selectedItem.id = this.article.articleId;
                this.inEditMode = false;
                this.article.scheduledDate = null;
                this.article.scheduledTime = this.getDefaultTime();
                this.setTimeZoneByPreference();
                this.remainingImageContents = this.maxImageContents;
                this.remainingTextContents = this.maxTextContents;
                this.remainingVideoContents = this.maxTextContents;
            },
            error: (error) => this.onApiError(error)
        });
    }


    private setRemainingReleaseCounts(releaseCounts: ReleaseCountViewModel[]): void {
        releaseCounts.forEach(regionCounts => {
            const remaingReleases = regionCounts.totalReleaseCount - regionCounts.usedReleaseCount;

            switch (regionCounts.regionName) {
                case DistributionRegionsEnum.US:
                    this.remainingUSReleases = remaingReleases;
                    break;
                case DistributionRegionsEnum.UK:
                    this.remainingUKReleases = remaingReleases;
                    break;
                case DistributionRegionsEnum.Canada:
                    this.remainingCanadaReleases = remaingReleases;
                    break;
                case DistributionRegionsEnum.NorthAmerica:
                    this.remainingNorthAmericaReleases = remaingReleases;
            }
        });
    }


    ngOnInit() {
        this.setIndustryList();
        this.setPreferredMethodList();
        this.articleApi.getReleaseCounts().subscribe({
            next: (data) => {
                const releaseCounts: ReleaseCountViewModel[] = data;
                this.setRemainingReleaseCounts(releaseCounts);
            },
            error: (error) => this.onApiError(error)
        });

        this.activatedRoute.queryParams.subscribe(queryParams => {
            if (queryParams['distributionId'] && +queryParams['distributionId'] > 0) {
                this.showSupportDialog();
            }
        });
    }

    loadPreviewPanel(articleId: number) {
        if (this.inEditMode) {
            this.coreDialogService.open(
                ConfirmDialogComponent,
                {
                    inputs: {
                        heading: NewswireConstants.unsavedHeading,
                        messageHtml: NewswireConstants.unsavedMessageHtml,
                        okLabel: NewswireConstants.unsavedContinueLabel,
                        cancelLabel: NewswireConstants.unsavedCancelLabel
                    },
                    outputs: {
                        dialogClose: (confirmed: boolean) => {
                            if (confirmed) {
                                this.getArticle(articleId, false);
                            } else {
                                this.selectedItem.id = this.article.articleId;
                            }
                        }
                    }
                }
            );
        } else {
            this.getArticle(articleId, false);
        }
    }

    private anonymizeArticle(article: ArticleViewModel): void {
        article.articleId = null;
        article.contacts.forEach(contact => {
            contact.articleContactId = null;
        });
        article.articleStatus = null;
        article.previewUrl = '';
        article.reportUrl = '';
        article.createdByUserId = null;
        article.createdDate = null;
        article.lastNotificationBody = null;
        article.lastNotificationHeadline = null;
    }

    private onGetArticle(article: ArticleViewModel, anonymize: boolean) {
        if (anonymize) {
            this.anonymizeArticle(article);
        } else if (this.accountName == null) {
            this.accountApiService.getAccount(article.accountId)
                .subscribe(account => {
                    this.accountName = account.name;
                });
        }

        this.article = article;
        this.selectedItem.id = this.article.articleId;
        this.contactsDataSource = new ContactsDataSource();
        this.article.contacts.forEach(contact => {
            this.contactsDataSource.addContact(this.articleContactToStoryContact(contact));
        });
        this.linksDataSource = new LinksDataSource();
        this.article.links.forEach(link => {
            this.linksDataSource.addLink({ id: 1, webAddress : link });
        });
        this.articleComponentViewModel.showLogo = (!Utils.isNullOrEmpty(this.article.companyLogo));
        this.articleComponentViewModel.showAboutUs = (!Utils.isNullOrEmpty(this.article.aboutUs));
        this.articleComponentViewModel.showImage = (!Utils.isNullOrEmpty(this.article.imageData));
        this.articleComponentViewModel.showContacts = (this.article.contacts.length > 0 );
        this.articleComponentViewModel.showLinks = (this.article.links.length > 0 );

        if (!this.article.bodyContents) {
            this.article.bodyContents = [];
        } else {
            this.article.bodyContents.sort(this.sortBodyContents);
        }
        this.updateRemainingBodyContents();

        if (article.scheduledDate) {
            this.article.scheduledTime = this.timeHelper.getTimeFromDate(article.scheduledDate, article.timeZone, timeFormatsEnum.twelveHour);
        } else {
            this.article.scheduledDate = null;
            this.article.scheduledTime = this.getDefaultTime();
        }

        if (article.datelineDate) {
            this.article.datelineDate = new Date(article.datelineDate);
        }

        if (article.timeZone) {
            this.article.scheduledTime.timeZone = article.timeZone;
        } else {
            this.setTimeZoneByPreference();
        }

        this.showStoryPreview = true;
        this.displayAmplifyDialog = false;
        this.showLoader = false;
        this.inEditMode = false;
    }

    private sortBodyContents(a: BodyContentsModel, b: BodyContentsModel): number {
        return a.orderId - b.orderId;
    }

    /**
    * Removes the empty body contents objects, and updates their orderIds
    */
    private prepareBodyContentsForSave(): void {
        const bodyContents = [];
        let orderId = 0;
        for (let i = 0, l = this.article.bodyContents.length; i < l; i++) {
            const bodyContent = this.article.bodyContents[i];
            if (!Utils.isNullOrEmpty(bodyContent.bodyContent)) {
                bodyContents.push(bodyContent);
                bodyContent.orderId = orderId;
                orderId++;
            }
        }
        this.article.bodyContents = bodyContents;
    }

    public showSupportDialog(): void {
        this.coreDialogService.open(
            ConfirmDialogComponent,
            {
                inputs: {
                    id: 'newsire.confirmdialog',
                    width: 500,
                    heading: 'Newswire',
                    messageHtml: 'We are currently upgrading your wire distribution options and improving the newswire submission process.<br/><br/>' +
                        'While we are completing this, your newswire requirements will be processed by your Agility Support team.<br/><br/>' +
                        // eslint-disable-next-line max-len
                        'Please submit your release and supporting information <a href="https://www.agilitypr.com/newswire-provisioning-form" target="_blank">here</a> and we will be in touch ASAP. Please note that all wire releases have associated costs, which can be provided by your Agility account representative.<br/><br/>' +
                        'Please contact <a href="https://www.agilitypr.com/support" target="_blank">Agility Support</a> with any questions.',
                    okLabel: 'Create Press Release'
                },
                outputs: {
                    dialogClose: (confirmed: boolean) => {
                        if (confirmed) {
                            window.open('https://www.agilitypr.com/newswire-provisioning-form');
                        }
                    }
                }
            }
        );
    }

    // @Deprecated - now we show a support message so new ones can't be added
    public showAmplifyDialog(): void {
        if (this.inEditMode) {
            this.coreDialogService.open(
                ConfirmDialogComponent,
                {
                    inputs: {
                        heading: NewswireConstants.unsavedHeading,
                        messageHtml: NewswireConstants.unsavedMessageHtml,
                        okLabel: NewswireConstants.unsavedContinueLabel,
                        cancelLabel: NewswireConstants.unsavedCancelLabel
                    },
                    outputs: {
                        dialogClose: (confirmed: boolean) => {
                            if (confirmed) {
                                this.setAmplifyData('');
                            }
                        }
                    }
                }
            );
        } else {
            this.setAmplifyData('');
        }
    }

    public setAmplifyData(searchText: string): void {
        this.storyList = [];
        const storySearchParams: StorySearchParams = new StorySearchParams();
        storySearchParams.start = 0;
        const emailRequest: EmailDistributionFilterModel = new EmailDistributionFilterModel();
        emailRequest.currentPageIndex = 1;
        emailRequest.searchText = searchText;
        this.showAmplifyLoading = true;
        this.displayAmplifyDialog = true;
        const newsroomFilterModel: NewsroomFilterModel = new NewsroomFilterModel();
        if (!Utils.isNullOrEmpty(searchText)) {
            newsroomFilterModel.storyNames = [];
            newsroomFilterModel.storyNames.push(searchText);
        }
        if (this.selectedAmplifyType === AmplifyTypesEnum.Recent) {
            storySearchParams.rows = this.amplifyMaxRecentResults;
            emailRequest.rowsPerPage = this.amplifyMaxRecentResults;
            forkJoin([
                this.newsroomApi.getNewroomStoryList(newsroomFilterModel, storySearchParams),
                this.articleApi.getArticleSummaries(searchText),
            ]).subscribe({
                next: (data) => this.onGetAmplifyDataRecent(data[0], data[1]),
                error: (error) => this.onApiError(error)
            });
        } else if (this.selectedAmplifyType === AmplifyTypesEnum.Newswire) {
            this.articleApi.getArticleSummaries(searchText)
                .subscribe({
                    next: (data) => this.onGetAmplifyDataType(data.totalCount, data.summaries, this.amplifyNewswireArticle),
                    error: (error) => this.onApiError(error)
                });
        } else if (this.selectedAmplifyType === AmplifyTypesEnum.Newsroom) {
            storySearchParams.rows = this.amplifyResultsPageSize;
            this.newsroomApi.getNewroomStoryList(newsroomFilterModel, storySearchParams)
                .subscribe({
                    next: (data) => this.onGetAmplifyDataType(data.totalCount, data.stories, this.amplifyNewsroomStory),
                    error: (error) => this.onApiError(error)
                });
        }
    }

    onAmplifyScrollLoadData(event): void {
        const keyword: string = event.keyword ? event.keyword : null;
        if (event.selectedType === AmplifyTypesEnum.Newsroom) {
            const newsroomFilterModel: NewsroomFilterModel = new NewsroomFilterModel();
            if (!Utils.isNullOrEmpty(keyword)) {
                newsroomFilterModel.storyNames = [];
                newsroomFilterModel.storyNames.push(keyword);
            }
            const storySearchParams: StorySearchParams = new StorySearchParams();
            storySearchParams.start = this.amplifyTotalRecords;
            storySearchParams.rows = event.rows;
            this.newsroomApi.getNewroomStoryList(newsroomFilterModel, storySearchParams)
                .subscribe({
                    next: (data) => this.onGetAmplifyPageType(data.stories, this.amplifyNewsroomStory),
                    error: (error) => this.onApiError(error)
                });
        }
    }

    onAmplifyCancel(): void {
        this.displayAmplifyDialog = false;
        this.selectedAmplifyType = AmplifyTypesEnum.Recent;
    }

    onAmplifyClose(): void {
        this.displayAmplifyDialog = false;
        this.selectedAmplifyType = AmplifyTypesEnum.Recent;
    }

    onAmplifySelect(selectedItem: AmplifyTypesEnum): void {
        this.selectedAmplifyType = selectedItem;
        this.setAmplifyData('');
        this.selectedAmplifyType = AmplifyTypesEnum.Recent;
    }

    onAmplifySearch(searchText: string): void {
        this.setAmplifyData(searchText);
    }

    private amplifyNewsroomStory(story: StoryModel): StoryModel {
        story.type = AmplifyTypesEnum.Newsroom;
        story.createdDate = new Date(story.modifiedDate);
        return story;
    }
    private amplifyNewswireArticle(article: ArticleSummaryViewModel): StoryModel {
        const storyModel = new StoryModel();
        storyModel.id = article.articleId;
        storyModel.name = article.articleName;
        storyModel.type = AmplifyTypesEnum.Newswire;
        storyModel.createdDate = article.lastModifiedDate;
        return storyModel;
    }

    private onGetAmplifyDataType(count: number, results: any[], mapToAmplifyStory: (item: any) => StoryModel): void {
        this.amplifyTotalRecords = count;
        this.storyList = results.map(mapToAmplifyStory);
        this.showAmplifyLoading = false;
    }
    private onGetAmplifyPageType(results: any[], mapToAmplifyStory: (item: any) => StoryModel): void {
        const mappedResults = results.map(mapToAmplifyStory);
        this.storyList.push(...mappedResults);
        this.showAmplifyLoading = false;
    }

    private onGetAmplifyDataRecent(
        newsroomStoriesResult: AmplifyStoryResultModel,
        articleSummaries: ArticleSummaryWithCountViewModel
    ): void {
        this.storyList = [];
        this.amplifyTotalRecords = 0;
        if (newsroomStoriesResult != null) {
            this.amplifyTotalRecords += newsroomStoriesResult.totalCount;
            const newsroomStories = newsroomStoriesResult.stories.map(this.amplifyNewsroomStory);
            this.storyList.push(...newsroomStories);
        }
        if (articleSummaries != null) {
            this.amplifyTotalRecords += articleSummaries.totalCount;
            const articleStories = articleSummaries.summaries.map(this.amplifyNewswireArticle);
            this.storyList.push(...articleStories);
        }
        this.storyList = this.storyList.sort((a, b) => new Date(b.createdDate).getTime() - new Date(a.createdDate).getTime());
        this.storyList = this.storyList.slice(0, this.amplifyMaxRecentResults);
        this.showAmplifyLoading = false;
    }

    public onAmplifyUseSelected(story: StoryModel): void {
        this.showLoader = true;
        this.displayAmplifyDialog = false;
        this.createdBy = '';
        if (story.type === AmplifyTypesEnum.Newswire) {
            this.getArticle(story.id, true);
        } else if (story.type === AmplifyTypesEnum.Newsroom) {
            this.newsroomApi.getNewroomStory(story.id)
                .subscribe({
                    next: (newsroomStory) => this.onGetNewsroomStory(newsroomStory),
                    error: (error) => this.onApiError(error)
                });
        }
    }

    private onGetNewsroomStory(story: UnifiedStoryResponseModel) {
        const article: ArticleViewModel = this.storyToArticle(story);
        this.onGetArticle(article, true);
    }

    private storyToArticle(story: UnifiedStoryResponseModel): ArticleViewModel {
        const article: ArticleViewModel = new ArticleViewModel();
        article.aboutUs = story.aboutUs;
        article.articleId = story.id;
        article.articleName = story.name;
        article.articleStatus = this.storyStatusToArticleStatus(story.statusId);
        article.body = story.body;
        article.bodyContents = [];
        if (story.datelineDate) {
            article.datelineDate = new Date(story.datelineDate);
        }
        if (story.datelineLocation) {
            article.datelineLocation = story.datelineLocation;
        }
        if (story.company != null) {
            article.companyName = story.company.name;
        }
        article.contacts = [];
        story.contacts.forEach(storyContact => {
            const articleContact: ArticleContactViewModel = this.storyContactToArticleContact(storyContact);
            article.contacts.push(articleContact);
            const storyContact2: any = storyContact; // had to trick typescript, because of inconsistencies in newsroom api/models
            if (storyContact2.imageId) {
                this.newsroomApi.getImageData(storyContact2.imageId).subscribe({
                    next: (imageData) => {
                        this.createImageFromBlob(
                            imageData,
                            image => {
                                const imgData: string = image.toString().replace(this.imageStreamBase64, '');
                                articleContact.imageData = imgData;
                                this.contactsDataSource.dataSource.find(item => item.name === storyContact.name).imageData = imgData;
                            }
                        );
                    },
                    error: (error) => this.onApiError(error)
                });
            }
        });
        article.headline = story.headline;
        this.article.bodyContents = [];
        if (story.bodyContents &&  story.bodyContents.length > 0) {
            story.bodyContents.forEach((bodyContent, index) => {
                if (bodyContent.bodyContentType === BodyContentTypesEnum.Image.toUpperCase()) {
                    this.newsroomApi.getImageData(bodyContent.bodyContentId).subscribe({
                        next: (imageData) => {
                            this.createImageFromBlob(
                                imageData,
                                image => {
                                    const imageRawData = image.toString().replace(this.imageStreamBase64, '');
                                    this.article.bodyContents.push(new BodyContentsModel(BodyContentTypesEnum.Image, imageRawData, index));
                                    this.remainingImageContents--;
                                    this.article.bodyContents.sort(this.sortBodyContents);
                                }
                            );
                        },
                        error: (error) => this.onApiError(error)
                    });
                } else {
                    article.bodyContents.push(new BodyContentsModel(BodyContentTypesEnum.Text, bodyContent.bodyContent, index));
                }
            });
        }
        if (story.company != null && story.company.imageId != null) {
            this.newsroomApi.getImageData(story.company.imageId).subscribe({
                next: (imageData) => {
                    this.createImageFromBlob(
                        imageData,
                        image => {
                            const imageRawData = image.toString().replace(this.imageStreamBase64, '');
                            this.article.companyLogo = imageRawData;
                            this.articleComponentViewModel.showLogo = (!Utils.isNullOrEmpty(this.article.companyLogo));
                        }
                    );
                },
                error: (error) => this.onApiError(error)
            });
        }
        article.links = [];
        story.links.forEach(link => {
            article.links.push(link.webAddress);
        });
        article.previewUrl = story.storySlug;
        return article;
    }

    private createImageFromBlob(
        imageBlob: Blob,
        callback
    ): void {
        const reader = new FileReader();
        reader.addEventListener('load', () => {
            callback(reader.result);
        }, false);

        if (imageBlob) {
            reader.readAsDataURL(imageBlob);
        }
    }

    showDialog(header: string, message: string): void {
        this.coreDialogService.open(
            ConfirmDialogComponent,
            <ConfirmDialogModel>{
                inputs: {
                    heading: header,
                    message: message,
                    showCancel: false
                }
            }
        );
    }

    private getArticle(articleId: number, anonymize: boolean): void {
        this.showLoader = true;

        this.articleApi.getArticle(articleId).subscribe({
            next: (article) => this.onGetArticle(article, anonymize),
            error: (error) => this.onApiError(error)
        });
    }

    setPreferredMethodList(): void {
        this.preferredMethodList.length = 0;
        this.preferredMethodOfContactApi.getPreferredMethodOfContacts().subscribe({
            next: (data) => {
                this.preferredMethodList = data.map((pair) => {
                    return {label: pair.name, value: pair.id};
                });
            },
            error: (error) => this.onApiError(error)
        });
    }

    setIndustryList(): void {
        this.industryList = [];
        this.industryApi.getIndustries()
            .subscribe({
                next: (data) => {
                    this.industryList = data.map((pair) => {
                        return {label: pair.name, value: pair.id};
                    });
                },
                error: (error) => this.onApiError(error)
            });
    }

    private storyStatusToArticleStatus(storyStatus: StatusEnum): ArticleStatusEnum {
        let articleStatus: ArticleStatusEnum = ArticleStatusEnum.Draft;
        if (storyStatus in this.storyStatusMapping) {
            articleStatus = this.storyStatusMapping[storyStatus];
        }
        return articleStatus;
    }

    private storyContactToArticleContact(storyContact: StoryContact) {
        const articleContact: ArticleContactViewModel = new ArticleContactViewModel();
        articleContact.articleContactId = storyContact.id;
        articleContact.contactAddress = storyContact.address;
        articleContact.contactName = storyContact.name;
        articleContact.emailAddress = storyContact.emailAddress;
        articleContact.mobileNumber = storyContact.mobileNumber;
        articleContact.phoneNumber = storyContact.phoneNumber;
        articleContact.title = storyContact.title;
        articleContact.webAddress = storyContact.webAddress;
        articleContact.imageData = storyContact.imageData;
        return articleContact;
    }

    private articleContactToStoryContact(
        articleContact: ArticleContactViewModel
    ) {
        const storyContact: StoryContact = new StoryContact();
        storyContact.address = articleContact.contactAddress;
        storyContact.name = articleContact.contactName;
        storyContact.emailAddress = articleContact.emailAddress;
        storyContact.mobileNumber = articleContact.mobileNumber;
        storyContact.phoneNumber = articleContact.phoneNumber;
        storyContact.title = articleContact.title;
        storyContact.webAddress = articleContact.webAddress;
        storyContact.imageData = articleContact.imageData;
        storyContact.id = articleContact.articleContactId;
        return storyContact;
    }

    saveArticle(): void {
        let isNewArticle = false;
        this.showLoader = true;
        this.article.accountName = this.accountName;
        this.prepareBodyContentsForSave();
        this.articleApi.getReleaseCounts().subscribe({
            next: (data) => {
                const releaseCounts: ReleaseCountViewModel[] = data;
                this.setRemainingReleaseCounts(releaseCounts);
                this.article.contacts = [];
                this.contactsDataSource.dataSource.forEach(storyContact => {
                    this.article.contacts.push(this.storyContactToArticleContact(storyContact));
                });
                this.article.links = [];
                this.linksDataSource.dataSource.forEach(link => {
                    this.article.links.push(link.webAddress);
                });
                if (this.article.articleStatus == null) {
                    this.article.articleStatus = ArticleStatusEnum.Draft;
                    isNewArticle = true;
                }

                this.article.timeZone = this.article.scheduledTime.timeZone;

                if (this.article.scheduledDate) {
                    this.article.scheduledDate = moment(this.article.scheduledDate).utc().toDate();
                }

                this.articleApi.saveArticle(this.article).subscribe({
                    next: (savedArticle) => {
                        if (isNewArticle) {
                            this.onNewArticleSaved(savedArticle);
                        } else {
                            this.onArticleSaved(savedArticle);
                        }
                    },
                    error: this.article.articleStatus === ArticleStatusEnum.Retracted
                        ? ((error) => this.onApiErrorRetracting(error))
                        : ((error) => this.onApiError(error))
                });
            },
            error: (error) => this.onApiError(error)
        });
    }

    onNewArticleSaved(savedArticle: ArticleViewModel): void {
        const message = NewswireConstants.pressReleaseMessage + savedArticle.articleName + NewswireConstants.createMessage;
        this.showMessage(NewswireConstants.createPressReleaseHeading, message, NewswireConstants.successSeverity);
        this.refreshArticleSummaries();
        this.getArticle(savedArticle.articleId, false);
    }

    onArticleSaved(savedArticle: ArticleViewModel): void {
        let message = NewswireConstants.pressReleaseMessage + savedArticle.articleName;
        let status: string|ArticleStatusEnum = savedArticle.articleStatus;
        if (typeof savedArticle.articleStatus === 'string') {
            status = ArticleStatusEnum[savedArticle.articleStatus];
        }
        switch (status) {
            case ArticleStatusEnum.Draft:
                message += NewswireConstants.updateMessage;
                this.showMessage(NewswireConstants.updatePressReleaseHeading, message, NewswireConstants.successSeverity);
                break;
            case ArticleStatusEnum.InReview:
                message += NewswireConstants.reviewMessage;
                this.showMessage(NewswireConstants.reviewPressReleaseHeading, message, NewswireConstants.successSeverity);
                break;
            case ArticleStatusEnum.Retracted:
                message += NewswireConstants.retractMessage;
                this.showMessage(NewswireConstants.retractPressReleaseHeading, message, NewswireConstants.successSeverity);
                break;
            case ArticleStatusEnum.Failed:
            case ArticleStatusEnum.Scheduled:
            case ArticleStatusEnum.Rejected:
            case ArticleStatusEnum.Posted:
                break;
        }
        this.refreshArticleSummaries();
        this.getArticle(savedArticle.articleId, false);
    }

    deleteArticle(sideBarItem: NewsroomSideBarItemModel): void {
        if (sideBarItem.status !== NewswireConstants.statusLabels[ArticleStatusEnum.Draft]) {
            this.showDialog(
                NewswireConstants.deleteFailedHeading,
                NewswireConstants.deleteFailedMessage
            );
            return;
        }
        const message = [
            NewswireConstants.deleteMessage,
            NewswireConstants.deleteItemsStart,
            NewswireConstants.deleteItemStart,
            sideBarItem.name,
            NewswireConstants.deleteItemEnd,
            NewswireConstants.deleteItemsEnd
        ].join('');
        this.coreDialogService.open(
            ConfirmDialogComponent,
            {
                inputs: {
                    heading: NewswireConstants.deleteHeading,
                    messageHtml: message,
                    okLabel: NewswireConstants.deleteConfirmLabel,
                    cancelLabel: NewswireConstants.deleteCancelLabel,
                    width: 350
                },
                outputs: {
                    dialogClose: (confirmed: boolean) => {
                        if (confirmed) {
                            this.showLoader = true;
                            this.articleApi.deleteArticle(sideBarItem.id).subscribe({
                                next: () => {
                                    const growlMessage = NewswireConstants.pressReleaseMessage + sideBarItem.name + NewswireConstants.deteleInfoMessage;
                                    this.showMessage(NewswireConstants.detelePressReleaseHeading, growlMessage, NewswireConstants.successSeverity);
                                    this.refreshArticleSummaries();
                                    this.showStoryPreview = false;
                                    this.showLoader = false;
                                },
                                error: (error) => this.onApiError(error)
                            });
                        }
                    }
                }
            }
        );
    }

    // rightsidebarinterface implementation.begin

    getTagNameById(tagId): string {
        // TODO : remove this later
        return '';
    }

    removeTag(tagId: number): void {
        // TODO : remove this later
    }

    displayTagDialogBox(): void {
        // TODO : remove this later
    }

    imageClick(type: string): void {
        if (type === 'image' && this.remainingImageContents > 0) {
            this.article.bodyContents.push(new BodyContentsModel(BodyContentTypesEnum.Image, ''));
            this.remainingImageContents--;
        } else if (type === 'logo') {
            this.articleComponentViewModel.showLogo = !this.articleComponentViewModel.showLogo;
        }
    }
    textClick(): void {
        if (this.remainingTextContents > 0) {
            this.article.bodyContents.push(new BodyContentsModel(BodyContentTypesEnum.Text, ''));
            this.remainingTextContents--;
        }
    }
    videoClick(): void {
        if (this.remainingVideoContents > 0) {
            this.article.bodyContents.push(new BodyContentsModel(BodyContentTypesEnum.Video, ''));
            this.remainingVideoContents--;
        }
    }

    toggleAboutUs(): void {
        this.articleComponentViewModel.showAboutUs = !this.articleComponentViewModel.showAboutUs;
    }

    toggleContact(): void {
        this.articleComponentViewModel.showContacts = !this.articleComponentViewModel.showContacts;
    }

    toggleLink(): void {
        this.articleComponentViewModel.showLinks = !this.articleComponentViewModel.showLinks;
    }


    onModelChanged(isEditMode: boolean): void {
        this.inEditMode = isEditMode;
        this.updateRemainingBodyContents();
    }

    updateRemainingBodyContents(): void {
        this.remainingImageContents = this.maxImageContents;
        this.remainingTextContents = this.maxTextContents;
        this.remainingVideoContents = this.maxTextContents;
        if (!this.article.bodyContents) {
            // if the article doesn't have bodyContents, then leave the values at max
            return;
        }
        for (const bodyContent of this.article.bodyContents) {
            if (bodyContent.bodyContentType === BodyContentTypesEnum.Text) {
                this.remainingTextContents--;
            } else if (bodyContent.bodyContentType === BodyContentTypesEnum.Image) {
                this.remainingImageContents--;
            } else if (bodyContent.bodyContentType === BodyContentTypesEnum.Video) {
                this.remainingVideoContents--;
            }
        }
    }

    setSubjects(selectedItem): void {
    }
    // rightsidebarinterface implementation.ends

    /**
    * Returns a boolean representation of whether the publishDate is set or not
    */
    hasPublishDate(): boolean {
        const hasValue: boolean = this.publishDate !== null && this.publishDate !== undefined;
        const isDate: boolean = this.publishDate instanceof Date;
        let hasPublishDate: boolean = false;

        if (hasValue && isDate) {
            hasPublishDate = true;
        }

        return hasPublishDate;
    }

    private getDefaultTime(): TimeModel {
        return new TimeModel();
    }

    /**
    * Sets the article timezone based on the user's preference settings
    */
    private setTimeZoneByPreference(): void {
        const canSetTimeZone: boolean = this.article.scheduledTime !== null && typeof this.article.scheduledTime === 'object';
        const hasPreferences: boolean = this.preferences instanceof PreferencesModel;

        if (canSetTimeZone && hasPreferences) {
            this.article.scheduledTime.timeZone = this.preferences.timeZone;
        }
    }

    /**
    * Sets the min date based on a continually updating date
    * with an offset of 1 hour and 75 minutes
    */
    private setMinSchedulingDate(): void {
        const editingDelayInMinutes: number = this.editingDelay;
        const oneHourInMinutes: number = 60;
        const hoursFromNow: number = Math.floor(editingDelayInMinutes / oneHourInMinutes);
        const minutesFromNow: number = editingDelayInMinutes % oneHourInMinutes;

        this.dateHelper.getOffsetDate(hoursFromNow, minutesFromNow, tensesEnum.future)
            .subscribe(
                offsetDate => this.minDate = offsetDate
            );
    }

    /**
    * Sets the editing delay in minutes based on an environment variable
    */
    private setEditingDelay(): void {
        const oneHourInMinutes: number = 60;
        const fallbackEditingDelay: number = oneHourInMinutes * 2;

        this.editingDelay = this.configService.getConfig().accesswireEditingDelay;

        if (this.editingDelay == null) {
            this.editingDelay = fallbackEditingDelay;
        }
    }

    /**
    * Set NewroomMode based on account permission
    */
    private setNewsroomMode(permissions: userPermissionsEnum[]): void {
        if (!permissions) {
            return;
        }
        const newroomMode = permissions.includes(NewswireConstants.newsroomMenuValue);
        if (newroomMode) {
            this.sidebarSections.unshift(
                new DropdownOptionModel(
                    NewswireConstants.sidebarSectionNewsroom,
                    '/Newsroom'
                )
            );
            this.sidebarSections = this.sidebarSections.slice();
        }
    }

    //#region Subscriptions

    /**
    * Creates the subscriptions this component relies on
    */
    private createSubscriptions(): void {
        this.subscriptions = [];

        this.createPreferencesSubscription();
        this.createPermissionsSubscription();
    }

    /**
    * Creates the preferences subscription
    */
    private createPreferencesSubscription(): void {
        this.subscriptions.push(
            this.currentUserStateService
                .getPreferences()
                .pipe(filter(x => !!x))
                .subscribe(
                    preferences => this.onPreferencesChange(preferences)
                )
        );
    }

    /**
    * Creates the permissions subscription
    */
    private createPermissionsSubscription(): void {
        this.subscriptions.push(
            this.currentUserStateService
                .getPermissions()
                .subscribe(
                    permissions => this.onPermissionsChange(permissions)
                )
        );
    }

    /**
    * Responds to changes in the current user's preferences
    */
    private onPreferencesChange(preferences: PreferencesModel): void {
        this.preferences = preferences;
    }

    /**
    * Responds to changes in the current user's permissions
    */
    private onPermissionsChange(permissions: userPermissionsEnum[]): void {
        this.setNewsroomMode(permissions);
    }

    //#endregion Subscriptions

    buttonClicked(): void {
        this.showSupportDialog();
    }

    secondaryButtonClicked(): void {}
}
